import { render, staticRenderFns } from "./SvgChevronRight.vue?vue&type=template&id=7e3916e2&lang=pug&"
import script from "./SvgChevronRight.vue?vue&type=script&lang=js&"
export * from "./SvgChevronRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports